import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import theme from "./theme";
import App from "./App";

// Quality floor: honor reduced-motion, and keep a visible keyboard focus ring.
const globals = (
  <GlobalStyles
    styles={{
      "@media (prefers-reduced-motion: reduce)": {
        "*, *::before, *::after": { animationDuration: "0.001ms !important", transition: "none !important" },
      },
      ":focus-visible": { outline: "2px solid #2E8BE6", outlineOffset: "2px" },
    }}
  />
);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globals}
      <BrowserRouter basename="/admin">
        <App />
      </BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={2600} hideProgressBar newestOnTop theme="colored" />
    </ThemeProvider>
  </React.StrictMode>
);
